export default __webpack_public_path__ + "static/media/rain-night.bcabe4fb.svg";